module.exports = __webpack_public_path__ + "media/bootstrap-icons/broadcast-b0e88583.svg";